import { differenceInDays, endOfDay, startOfDay } from "date-fns";

import { SurveyModel } from "@performyard/service-contracts";

export const getCurrentPeriod = (status: SurveyModel["status"], startDate: string | null, endDate: string | null) => {
	let value = 0;
	let dayOrDays = "Days";
	switch (status) {
		case "scheduled":
			if (startDate && !endDate) {
				return {
					label: [dayOrDays, "Open"],
					value: 0,
				};
			} else if (startDate && endDate) {
				value = differenceInDays(endOfDay(new Date(endDate)), startOfDay(new Date(startDate))) + 1;
				dayOrDays = value === 1 ? "Day" : "Days";
				return {
					label: [dayOrDays, "Remaining"],
					value,
				};
			}
			return { label: ["Days", "Open"], value: 0 };
		case "active":
			if (!startDate) {
				return { label: ["Days", "Open"], value: 0 };
			}
			value = endDate
				? differenceInDays(endOfDay(new Date(endDate)), new Date()) + 1
				: differenceInDays(new Date(), startOfDay(new Date(startDate))) + 1;
			dayOrDays = value === 1 ? "Day" : "Days";
			return {
				label: endDate ? [dayOrDays, "Remaining"] : [dayOrDays, "Open"],
				value,
			};
		case "closed":
			value =
				endDate && startDate
					? differenceInDays(endOfDay(new Date(endDate)), startOfDay(new Date(startDate))) + 1
					: 0;
			dayOrDays = value === 1 ? "Day" : "Days";
			return {
				label: [dayOrDays, "Open"],
				value,
			};
		default:
			return { label: ["Days", "Open"], value: 0 };
	}
};
